import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";

const DEFAULT_VISIBILITY = {
  about: true,
  services: true,
  portfolio: true,
  packages: true,
  contact: true,
  testimonials: true,
  pressStrip: true,
  certificates: true,
};

export function useSectionVisibility() {
  const [visibility, setVisibility] = useState(DEFAULT_VISIBILITY);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const snap = await getDoc(doc(db, "settings", "site"));
        if (snap.exists() && snap.data().sectionVisibility) {
          setVisibility({
            ...DEFAULT_VISIBILITY,
            ...snap.data().sectionVisibility,
          });
        }
      } catch (err) {
        console.warn("Settings unavailable, using defaults:", err.message);
      }
    };
    fetchSettings();
  }, []);

  return visibility;
}
